import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import VerifiedIcon from "@mui/icons-material/Verified";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SettingsIcon from "@mui/icons-material/Settings";
import { getBrowserLanguage, normalizeLanguage, translate } from "./i18n";

export const toolDisplayMapping = {
  car_stock_search: "toolCarStockSearch",
  car_stock: "toolCarStockSearch",
  car_configurator: "toolCarStockSearch",
  vehicle_details: "toolVehicleDetails",
  validate: "toolValidate",
  knowledge_search_engine: "toolKnowledgeSearch",
  booking_: "toolBookingCheck",
  book_: "toolBookAppointment",
  consultant_intervention: "toolConsultantIntervention",
  customer_registration: "toolCustomerRegistration",
  get_service_locations: "toolServiceLocations",
};

export const toolIconMapping = {
  car_stock_search: <SearchIcon fontSize="inherit" />,
  car_stock: <SearchIcon fontSize="inherit" />,
  car_configurator: <SearchIcon fontSize="inherit" />,
  vehicle_details: <DirectionsCarIcon fontSize="inherit" />,
  validate: <VerifiedIcon fontSize="inherit" />,
  knowledge_search_engine: <MenuBookIcon fontSize="inherit" />,
  booking_: <CalendarMonthIcon fontSize="inherit" />,
  book_: <CalendarMonthIcon fontSize="inherit" />,
  consultant_intervention: <SupportAgentIcon fontSize="inherit" />,
  customer_registration: <PersonAddIcon fontSize="inherit" />,
  get_service_locations: <LocationOnIcon fontSize="inherit" />,
  default: <SettingsIcon fontSize="inherit" />,
};

const normalizeToolNames = (tool) => {
  if (Array.isArray(tool)) {
    return tool.filter((name) => typeof name === "string" && name.length > 0);
  }

  if (typeof tool === "string" && tool.length > 0) {
    return [tool];
  }

  return [];
};

const findMatchingToolKey = (toolNames, mapping) => {
  for (const toolName of toolNames) {
    if (mapping[toolName]) {
      return toolName;
    }

    const prefixMatch = Object.keys(mapping).find((key) => toolName.startsWith(key));
    if (prefixMatch) {
      return prefixMatch;
    }
  }

  return null;
};

export const getToolDisplay = (tool, language) => {
  const lang = normalizeLanguage(language || getBrowserLanguage());
  const toolNames = normalizeToolNames(tool);
  const matchingKey = findMatchingToolKey(toolNames, toolDisplayMapping);

  if (matchingKey) {
    return translate(toolDisplayMapping[matchingKey], lang);
  }

  return translate("toolProcessing", lang);
};

export const getToolIcon = (tool) => {
  const toolNames = normalizeToolNames(tool);
  const matchingKey = findMatchingToolKey(toolNames, toolIconMapping);

  if (matchingKey) {
    return toolIconMapping[matchingKey];
  }

  return toolIconMapping.default;
};
